// FIXME: https://github.com/import-js/eslint-plugin-import/pull/2716
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React, { createContext, useContext } from 'react';
import {
  getZoneFromSite,
  type Language,
  siteConfig,
  siteNames,
  getLanguageFromLocale,
  type Country,
} from '@seek/melways-sites';
import { Environment } from '../services/environment';
import type { EmployerSiteName } from '../../types';

interface AppContextContents {
  site: EmployerSiteName;
  environment: Environment;
  language: string;
  brand: string;
  country: Country;
  zone: string;
}

const defaultSite = siteNames.employer.seek.au;
const defaultContents: AppContextContents = {
  site: defaultSite,
  environment: Environment.local,
  language: 'en',
  zone: 'anz-1',
  brand: 'seek',
  country: 'au',
};

const AppContext = createContext<AppContextContents>(defaultContents);

interface AppContextProviderProps {
  site: EmployerSiteName;
  language: string;
  environment: Environment;
}

const AppContextProvider: React.FC<
  React.PropsWithChildren<AppContextProviderProps>
> = ({ site, language: localeLanguage, environment, children }) => {
  const brand = siteConfig[site].classification.brand;
  const country = siteConfig[site].classification.country;
  const language = getLanguageFromLocale(localeLanguage as Language);

  const zone = getZoneFromSite(site);

  return (
    <AppContext.Provider
      value={{ site, environment, language, zone, brand, country }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => useContext(AppContext);

export type { AppContextContents };
export { AppContextProvider, useAppContext };
